var _title, _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgTutorialDashboardIcon = function SvgTutorialDashboardIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Menu/ Dashboard")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Menu/-Dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.25,19.0669873 C14.7687831,19.0669873 16,17.9304794 16,16.5285258 C16,15.59389 15.0833333,12.7733772 13.25,8.0669873 C11.4166667,12.7733772 10.5,15.59389 10.5,16.5285258 C10.5,17.9304794 11.7312169,19.0669873 13.25,19.0669873 Z",
    id: "Oval",
    stroke: "#B2B2B2",
    strokeWidth: 1.5,
    transform: "translate(13.250000, 13.566987) rotate(-30.000000) translate(-13.250000, -13.566987) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,17 L2,17 L2,16 C2,9 7.5,4 14,4 C20.5,4 26,9 26,16 L26,17 L21,17",
    id: "Path-3",
    stroke: "#B2B2B2",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-5",
    stroke: "#B2B2B2",
    strokeWidth: 1.5,
    points: "2 21 2 24 26 24 26 21"
  }))));
};

export default __webpack_public_path__ + "static/media/tutorial-dashboard-icon.c5d3517f.svg";
export { SvgTutorialDashboardIcon as ReactComponent };